export const translations = {
  pl: {
    // Navigation
    nav: {
      home: 'Strona główna',
      tracking: 'Śledzenie',
      services: 'Usługi',
      about: 'O nas',
      contact: 'Kontakt',
      order: 'Zamówienie',
      admin: 'Admin'
    },
    
    // Common
    common: {
      loading: 'Ładowanie...',
      error: 'Błąd',
      success: 'Sukces',
      cancel: 'Anuluj',
      save: 'Zapisz',
      edit: 'Edytuj',
      delete: 'Usuń',
      search: 'Szukaj',
      filter: 'Filtruj',
      refresh: 'Odśwież',
      details: 'Szczegóły',
      close: 'Zamknij',
      back: 'Wróć',
      next: 'Dalej',
      previous: 'Poprzedni',
      submit: 'Wyślij',
      phone: 'Telefon',
      email: 'Email',
      address: 'Adres',
      name: 'Imię i nazwisko',
      amount: 'Kwota',
      currency: 'Waluta',
      status: 'Status',
      date: 'Data',
      notes: 'Uwagi'
    },

    // Home page
    home: {
      hero: {
        title: 'Szybkie i bezpieczne przelewy gotówkowe',
        subtitle: 'EXPRESS HUB - Twój niezawodny partner w międzynarodowych transferach pieniężnych',
        trackButton: 'Śledź przesyłkę',
        orderButton: 'Złóż zamówienie'
      },
      features: {
        title: 'Dlaczego EXPRESS HUB?',
        subtitle: 'Profesjonalne usługi kurierskie z gwarancją bezpieczeństwa',
        speed: {
          title: 'Szybka dostawa',
          description: 'Ekspresowa dostawa w 24-48 godzin'
        },
        security: {
          title: 'Pełne bezpieczeństwo',
          description: 'Ubezpieczenie i śledzenie każdej przesyłki'
        },
        support: {
          title: 'Wsparcie 24/7',
          description: 'Profesjonalna obsługa klienta przez całą dobę'
        }
      },
      stats: {
        deliveries: 'Zrealizowanych przesyłek',
        countries: 'Krajów obsługi',
        satisfaction: 'Zadowolonych klientów',
        experience: 'Lat doświadczenia'
      }
    },

    // Tracking page
    tracking: {
      title: 'Śledzenie przesyłki',
      subtitle: 'Sprawdź aktualny status swojego zamówienia',
      placeholder: 'Wprowadź numer przesyłki (np. EH123456)',
      searchButton: 'Szukaj',
      notFound: 'Nie znaleziono przesyłki o podanym numerze',
      error: 'Wystąpił błąd podczas wyszukiwania',
      orderNumber: 'Numer zamówienia',
      recipient: 'Odbiorca',
      applicant: 'Wnioskodawca',
      amount: 'Kwota do wypłaty',
      totalAmount: 'Łączna kwota',
      deliveryType: 'Typ dostawy',
      orderDate: 'Data zamówienia',
      contactUs: 'Skontaktuj się z nami w sprawie swojego zamówienia',
      callButton: 'Zadzwoń',
      emailButton: 'Napisz email',
      refreshStatus: 'Odśwież status',
      status: {
        unpaid: 'Nieopłacone',
        pending: 'Oczekuje potwierdzenia',
        confirmed: 'Potwierdzone',
        inTransit: 'W drodze',
        delivered: 'Dostarczone',
        cancelled: 'Anulowane'
      }
    },

    // Order page
    order: {
      title: 'Złóż wniosek',
      subtitle: 'Wypełnij formularz wniosku o transfer gotówkowy',
      senderDetails: 'Dane wnioskodawcy',
      orderDetails: 'Szczegóły wniosku',
      personalData: 'Dane osobowe',
      financialDetails: 'Szczegóły finansowe',
      senderName: 'Imię i nazwisko',
      senderPhone: 'Telefon',
      senderEmail: 'Email',
      senderAddress: 'Adres',
      transferAmount: 'Kwota do przesłania',
      deliveryType: 'Typ dostawy',
      express: 'Ekspresowa (24-48h)',
      standard: 'Standardowa (3-5 dni)',
      serviceFee: 'Opłata za usługę',
      insurance: 'Kaucja ubezpieczenia przesyłki',
      totalCost: 'Łączny koszt',
      submitButton: 'Złóż zamówienie',
      submitting: 'Wysyłanie...',
      orderPlaced: 'Zamówienie złożone!',
      orderAccepted: 'Twoje zamówienie zostało przyjęte do realizacji.',
      orderNumber: 'Numer zamówienia',
      contactInfo: 'Skontaktujemy się z Tobą w ciągu 24 godzin w celu potwierdzenia szczegółów.',
      trackOrder: 'Śledź zamówienie',
      placeAnother: 'Złóż kolejne zamówienie',
      contactUs: 'Lub skontaktuj się z nami',
      maxAmount: 'Maksymalna kwota: 800,000 (w wybranej walucie)'
    },

    // Services page
    services: {
      title: 'Nasze usługi',
      subtitle: 'Kompleksowe rozwiązania w zakresie transferów gotówkowych',
      cashTransfer: {
        title: 'Transfer gotówkowy',
        description: 'Bezpieczne przelewy gotówkowe z pełnym ubezpieczeniem'
      },
      expressDelivery: {
        title: 'Dostawa ekspresowa',
        description: 'Szybka dostawa w 24-48 godzin na terenie Europy'
      },
      tracking: {
        title: 'Śledzenie online',
        description: 'Monitoruj status swojej przesyłki w czasie rzeczywistym'
      },
      insurance: {
        title: 'Pełne ubezpieczenie',
        description: 'Każda przesyłka objęta jest pełnym ubezpieczeniem'
      },
      support: {
        title: 'Wsparcie 24/7',
        description: 'Profesjonalna obsługa klienta przez całą dobę'
      },
      consultation: {
        title: 'Konsultacje',
        description: 'Bezpłatne konsultacje w zakresie transferów międzynarodowych'
      },
      ctaTitle: 'Potrzebujesz pomocy?',
      ctaDescription: 'Skontaktuj się z nami, aby uzyskać więcej informacji o naszych usługach.',
      contactButton: 'Skontaktuj się',
      callButton: 'Zadzwoń teraz'
    },

    // About page
    about: {
      title: 'O EXPRESS HUB',
      subtitle: 'Lider w branży transferów gotówkowych',
      description: 'EXPRESS HUB to nowoczesna firma specjalizująca się w bezpiecznych transferach gotówkowych. Działamy na rynku europejskim, oferując szybkie i niezawodne usługi kurierskie.',
      mission: {
        title: 'Nasza misja',
        description: 'Zapewniamy bezpieczne i szybkie transfery gotówkowe, budując zaufanie klientów poprzez profesjonalizm i niezawodność.'
      },
      values: {
        title: 'Nasze wartości',
        security: 'Bezpieczeństwo',
        reliability: 'Niezawodność',
        speed: 'Szybkość',
        trust: 'Zaufanie'
      },
      team: {
        title: 'Nasz zespół',
        description: 'Doświadczeni specjaliści z wieloletnim stażem w branży finansowej i logistycznej.'
      },
      contact: {
        title: 'Skontaktuj się z nami',
        description: 'Jesteśmy dostępni 24/7, aby odpowiedzieć na Twoje pytania.'
      }
    },

    // Contact page
    contact: {
      title: 'Kontakt',
      subtitle: 'Skontaktuj się z nami',
      form: {
        title: 'Wyślij wiadomość',
        name: 'Imię i nazwisko',
        email: 'Adres email',
        phone: 'Telefon',
        subject: 'Temat',
        message: 'Wiadomość',
        submit: 'Wyślij wiadomość',
        sending: 'Wysyłanie...',
        success: 'Wiadomość została wysłana!',
        error: 'Wystąpił błąd podczas wysyłania wiadomości.'
      },
      info: {
        phone: {
          title: 'Telefon',
          description: 'Odpowiedź w 24h'
        },
        email: {
          title: 'Email',
          description: 'Odpowiedź w 24h'
        },
        address: {
          title: 'Adres',
          description: '6883 Novazzano, Szwajcaria'
        },
        hours: {
          title: 'Godziny otwarcia',
          description: 'Weekendy: 11:00-16:00'
        }
      },
      callNow: 'Zadzwoń teraz'
    },

    // Admin panel
    admin: {
      title: 'Panel Administracyjny',
      subtitle: 'Zarządzaj zamówieniami EXPRESS HUB',
      stats: {
        total: 'Wszystkie',
        unpaid: 'Nieopłacone',
        pending: 'Oczekuje potwierdzenia',
        confirmed: 'Potwierdzone',
        inTransit: 'W drodze',
        delivered: 'Dostarczone',
        cancelled: 'Anulowane'
      },
      filters: {
        title: 'Filtry i wyszukiwanie',
        searchPlaceholder: 'Szukaj po numerze, nazwisku, email...',
        allStatuses: 'Wszystkie statusy'
      },
      orders: {
        title: 'Zamówienia',
        noOrders: 'Brak zamówień do wyświetlenia',
        sender: 'Nadawca',
        recipient: 'Odbiorca',
        orderDetails: 'Szczegóły zamówienia',
        senderData: 'Dane nadawcy',
        recipientData: 'Dane odbiorcy',
        financialDetails: 'Szczegóły finansowe',
        additionalInfo: 'Informacje dodatkowe',
        serviceAmount: 'Kwota do przesłania',
        serviceFee: 'Opłata za usługę',
        insurance: 'Ubezpieczenie',
        totalAmount: 'Łączna kwota',
        deliveryType: 'Typ dostawy',
        orderDate: 'Data złożenia',
        expressDelivery: 'Ekspresowa (24-48h)',
        standardDelivery: 'Standardowa (3-5 dni)',
        updateSuccess: 'Status zamówienia został zaktualizowany',
        updateError: 'Błąd podczas aktualizacji statusu'
      }
    },

    // Status labels
    status: {
      unpaid: 'Nieopłacone',
      pending: 'Oczekuje potwierdzenia',
      confirmed: 'Potwierdzone',
      inTransit: 'W drodze',
      delivered: 'Dostarczone',
      cancelled: 'Anulowane'
    },

    // Status descriptions
    statusDesc: {
      unpaid: 'Zamówienie oczekuje na opłacenie. Skontaktuj się z nami w celu uregulowania płatności.',
      pending: 'Twoje zamówienie zostało przyjęte i oczekuje na potwierdzenie',
      confirmed: 'Zamówienie zostało potwierdzone i przygotowywane do wysyłki',
      inTransit: 'Przesyłka jest w drodze do odbiorcy',
      delivered: 'Przesyłka została dostarczona do odbiorcy',
      cancelled: 'Zamówienie zostało anulowane'
    },

    // Footer
    footer: {
      description: 'EXPRESS HUB - Profesjonalne usługi kurierskie i transfery gotówkowe.',
      quickLinks: 'Szybkie linki',
      services: 'Usługi',
      contact: 'Kontakt',
      hours: 'Godziny',
      workingHours: 'Pn-Pt 8:00-18:00, Sb-Nd: 11:00-16:00',
      copyright: '© 2026 EXPRESS HUB. Wszelkie prawa zastrzeżone.'
    },

    // Working hours
    workingHours: {
      weekdays: 'Pn-Pt: 8:00-18:00',
      weekends: 'Sb-Nd: 11:00-16:00',
      full: 'Pn-Pt 8:00-18:00, Sb-Nd: 11:00-16:00'
    }
  },

  en: {
    // Navigation
    nav: {
      home: 'Home',
      tracking: 'Tracking',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      order: 'Order',
      admin: 'Admin'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      filter: 'Filter',
      refresh: 'Refresh',
      details: 'Details',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      name: 'Full name',
      amount: 'Amount',
      currency: 'Currency',
      status: 'Status',
      date: 'Date',
      notes: 'Notes'
    },

    // Home page
    home: {
      hero: {
        title: 'Fast and secure cash transfers',
        subtitle: 'EXPRESS HUB - Your reliable partner for international money transfers',
        trackButton: 'Track shipment',
        orderButton: 'Place order'
      },
      features: {
        title: 'Why EXPRESS HUB?',
        subtitle: 'Professional courier services with security guarantee',
        speed: {
          title: 'Fast delivery',
          description: 'Express delivery in 24-48 hours'
        },
        security: {
          title: 'Full security',
          description: 'Insurance and tracking for every shipment'
        },
        support: {
          title: '24/7 support',
          description: 'Professional customer service around the clock'
        }
      },
      stats: {
        deliveries: 'Completed deliveries',
        countries: 'Countries served',
        satisfaction: 'Satisfied customers',
        experience: 'Years of experience'
      }
    },

    // Tracking page
    tracking: {
      title: 'Track shipment',
      subtitle: 'Check the current status of your order',
      placeholder: 'Enter tracking number (e.g. EH123456)',
      searchButton: 'Search',
      notFound: 'No shipment found with the given number',
      error: 'An error occurred while searching',
      orderNumber: 'Order number',
      recipient: 'Recipient',
      applicant: 'Applicant',
      amount: 'Amount to pay',
      totalAmount: 'Total amount',
      deliveryType: 'Delivery type',
      orderDate: 'Order date',
      contactUs: 'Contact us about your order',
      callButton: 'Call',
      emailButton: 'Send email',
      refreshStatus: 'Refresh status',
      status: {
        unpaid: 'Unpaid',
        pending: 'Pending confirmation',
        confirmed: 'Confirmed',
        inTransit: 'In transit',
        delivered: 'Delivered',
        cancelled: 'Cancelled'
      }
    },

    // Order page
    order: {
      title: 'Submit application',
      subtitle: 'Fill out the cash transfer application form',
      senderDetails: 'Applicant details',
      orderDetails: 'Application details',
      personalData: 'Personal data',
      financialDetails: 'Financial details',
      senderName: 'Full name',
      senderPhone: 'Phone',
      senderEmail: 'Email',
      senderAddress: 'Address',
      transferAmount: 'Amount to transfer',
      deliveryType: 'Delivery type',
      express: 'Express (24-48h)',
      standard: 'Standard (3-5 days)',
      serviceFee: 'Service fee',
      insurance: 'Shipment insurance deposit',
      totalCost: 'Total cost',
      submitButton: 'Place order',
      submitting: 'Submitting...',
      orderPlaced: 'Order placed!',
      orderAccepted: 'Your order has been accepted for processing.',
      orderNumber: 'Order number',
      contactInfo: 'We will contact you within 24 hours to confirm details.',
      trackOrder: 'Track order',
      placeAnother: 'Place another order',
      contactUs: 'Or contact us',
      maxAmount: 'Maximum amount: 800,000 (in selected currency)'
    },

    // Services page
    services: {
      title: 'Our services',
      subtitle: 'Comprehensive cash transfer solutions',
      cashTransfer: {
        title: 'Cash transfer',
        description: 'Secure cash transfers with full insurance'
      },
      expressDelivery: {
        title: 'Express delivery',
        description: 'Fast delivery in 24-48 hours across Europe'
      },
      tracking: {
        title: 'Online tracking',
        description: 'Monitor your shipment status in real time'
      },
      insurance: {
        title: 'Full insurance',
        description: 'Every shipment is covered by full insurance'
      },
      support: {
        title: '24/7 support',
        description: 'Professional customer service around the clock'
      },
      consultation: {
        title: 'Consultations',
        description: 'Free consultations on international transfers'
      },
      ctaTitle: 'Need help?',
      ctaDescription: 'Contact us to learn more about our services.',
      contactButton: 'Contact us',
      callButton: 'Call now'
    },

    // About page
    about: {
      title: 'About EXPRESS HUB',
      subtitle: 'Leader in cash transfer industry',
      description: 'EXPRESS HUB is a modern company specializing in secure cash transfers. We operate in the European market, offering fast and reliable courier services.',
      mission: {
        title: 'Our mission',
        description: 'We provide secure and fast cash transfers, building customer trust through professionalism and reliability.'
      },
      values: {
        title: 'Our values',
        security: 'Security',
        reliability: 'Reliability',
        speed: 'Speed',
        trust: 'Trust'
      },
      team: {
        title: 'Our team',
        description: 'Experienced specialists with years of experience in the financial and logistics industry.'
      },
      contact: {
        title: 'Contact us',
        description: 'We are available 24/7 to answer your questions.'
      }
    },

    // Contact page
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us',
      form: {
        title: 'Send message',
        name: 'Full name',
        email: 'Email address',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message',
        submit: 'Send message',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'An error occurred while sending the message.'
      },
      info: {
        phone: {
          title: 'Phone',
          description: 'Response within 24h'
        },
        email: {
          title: 'Email',
          description: 'Response within 24h'
        },
        address: {
          title: 'Address',
          description: '6883 Novazzano, Switzerland'
        },
        hours: {
          title: 'Opening hours',
          description: 'Weekends: 11:00-16:00'
        }
      },
      callNow: 'Call now'
    },

    // Admin panel
    admin: {
      title: 'Admin Panel',
      subtitle: 'Manage EXPRESS HUB orders',
      stats: {
        total: 'Total',
        unpaid: 'Unpaid',
        pending: 'Pending confirmation',
        confirmed: 'Confirmed',
        inTransit: 'In transit',
        delivered: 'Delivered',
        cancelled: 'Cancelled'
      },
      filters: {
        title: 'Filters and search',
        searchPlaceholder: 'Search by number, name, email...',
        allStatuses: 'All statuses'
      },
      orders: {
        title: 'Orders',
        noOrders: 'No orders to display',
        sender: 'Sender',
        recipient: 'Recipient',
        orderDetails: 'Order details',
        senderData: 'Sender data',
        recipientData: 'Recipient data',
        financialDetails: 'Financial details',
        additionalInfo: 'Additional information',
        serviceAmount: 'Amount to transfer',
        serviceFee: 'Service fee',
        insurance: 'Insurance',
        totalAmount: 'Total amount',
        deliveryType: 'Delivery type',
        orderDate: 'Order date',
        expressDelivery: 'Express (24-48h)',
        standardDelivery: 'Standard (3-5 days)',
        updateSuccess: 'Order status updated successfully',
        updateError: 'Error updating order status'
      }
    },

    // Status labels
    status: {
      unpaid: 'Unpaid',
      pending: 'Pending confirmation',
      confirmed: 'Confirmed',
      inTransit: 'In transit',
      delivered: 'Delivered',
      cancelled: 'Cancelled'
    },

    // Status descriptions
    statusDesc: {
      unpaid: 'Order awaiting payment. Please contact us to arrange payment.',
      pending: 'Your order has been received and is awaiting confirmation',
      confirmed: 'Order has been confirmed and is being prepared for shipment',
      inTransit: 'Shipment is on its way to the recipient',
      delivered: 'Shipment has been delivered to the recipient',
      cancelled: 'Order has been cancelled'
    },

    // Footer
    footer: {
      description: 'EXPRESS HUB - Professional courier services and cash transfers.',
      quickLinks: 'Quick links',
      services: 'Services',
      contact: 'Contact',
      hours: 'Hours',
      workingHours: 'Mon-Fri 8:00-18:00, Sat-Sun: 11:00-16:00',
      copyright: '© 2026 EXPRESS HUB. All rights reserved.'
    },

    // Working hours
    workingHours: {
      weekdays: 'Mon-Fri: 8:00-18:00',
      weekends: 'Sat-Sun: 11:00-16:00',
      full: 'Mon-Fri 8:00-18:00, Sat-Sun: 11:00-16:00'
    }
  },

  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      tracking: 'Sendungsverfolgung',
      services: 'Dienstleistungen',
      about: 'Über uns',
      contact: 'Kontakt',
      order: 'Bestellung',
      admin: 'Admin'
    },
    
    // Common
    common: {
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      cancel: 'Abbrechen',
      save: 'Speichern',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      search: 'Suchen',
      filter: 'Filtern',
      refresh: 'Aktualisieren',
      details: 'Details',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Vorherige',
      submit: 'Senden',
      phone: 'Telefon',
      email: 'E-Mail',
      address: 'Adresse',
      name: 'Vollständiger Name',
      amount: 'Betrag',
      currency: 'Währung',
      status: 'Status',
      date: 'Datum',
      notes: 'Notizen'
    },

    // Home page
    home: {
      hero: {
        title: 'Schnelle und sichere Geldtransfers',
        subtitle: 'EXPRESS HUB - Ihr zuverlässiger Partner für internationale Geldtransfers',
        trackButton: 'Sendung verfolgen',
        orderButton: 'Bestellung aufgeben'
      },
      features: {
        title: 'Warum EXPRESS HUB?',
        subtitle: 'Professionelle Kurierdienste mit Sicherheitsgarantie',
        speed: {
          title: 'Schnelle Lieferung',
          description: 'Express-Lieferung in 24-48 Stunden'
        },
        security: {
          title: 'Vollständige Sicherheit',
          description: 'Versicherung und Verfolgung für jede Sendung'
        },
        support: {
          title: '24/7 Support',
          description: 'Professioneller Kundenservice rund um die Uhr'
        }
      },
      stats: {
        deliveries: 'Abgeschlossene Lieferungen',
        countries: 'Bediente Länder',
        satisfaction: 'Zufriedene Kunden',
        experience: 'Jahre Erfahrung'
      }
    },

    // Tracking page
    tracking: {
      title: 'Sendungsverfolgung',
      subtitle: 'Überprüfen Sie den aktuellen Status Ihrer Bestellung',
      placeholder: 'Sendungsnummer eingeben (z.B. EH123456)',
      searchButton: 'Suchen',
      notFound: 'Keine Sendung mit der angegebenen Nummer gefunden',
      error: 'Ein Fehler ist bei der Suche aufgetreten',
      orderNumber: 'Bestellnummer',
      recipient: 'Empfänger',
      applicant: 'Antragsteller',
      amount: 'Auszuzahlender Betrag',
      totalAmount: 'Gesamtbetrag',
      deliveryType: 'Lieferart',
      orderDate: 'Bestelldatum',
      contactUs: 'Kontaktieren Sie uns bezüglich Ihrer Bestellung',
      callButton: 'Anrufen',
      emailButton: 'E-Mail senden',
      refreshStatus: 'Status aktualisieren',
      status: {
        unpaid: 'Unbezahlt',
        pending: 'Wartet auf Bestätigung',
        confirmed: 'Bestätigt',
        inTransit: 'Unterwegs',
        delivered: 'Geliefert',
        cancelled: 'Storniert'
      }
    },

    // Order page
    order: {
      title: 'Antrag stellen',
      subtitle: 'Füllen Sie das Antragsformular für Geldtransfer aus',
      senderDetails: 'Antragsteller-Details',
      orderDetails: 'Antragsdetails',
      personalData: 'Persönliche Daten',
      financialDetails: 'Finanzielle Details',
      senderName: 'Vollständiger Name',
      senderPhone: 'Telefon',
      senderEmail: 'E-Mail',
      senderAddress: 'Adresse',
      transferAmount: 'Zu überweisender Betrag',
      deliveryType: 'Lieferart',
      express: 'Express (24-48h)',
      standard: 'Standard (3-5 Tage)',
      serviceFee: 'Servicegebühr',
      insurance: 'Versicherungskaution für Sendung',
      totalCost: 'Gesamtkosten',
      submitButton: 'Bestellung aufgeben',
      submitting: 'Wird gesendet...',
      orderPlaced: 'Bestellung aufgegeben!',
      orderAccepted: 'Ihre Bestellung wurde zur Bearbeitung angenommen.',
      orderNumber: 'Bestellnummer',
      contactInfo: 'Wir werden Sie innerhalb von 24 Stunden kontaktieren, um Details zu bestätigen.',
      trackOrder: 'Bestellung verfolgen',
      placeAnother: 'Weitere Bestellung aufgeben',
      contactUs: 'Oder kontaktieren Sie uns',
      maxAmount: 'Maximaler Betrag: 800.000 (in gewählter Währung)'
    },

    // Services page
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Umfassende Geldtransfer-Lösungen',
      cashTransfer: {
        title: 'Geldtransfer',
        description: 'Sichere Geldtransfers mit vollständiger Versicherung'
      },
      expressDelivery: {
        title: 'Express-Lieferung',
        description: 'Schnelle Lieferung in 24-48 Stunden in ganz Europa'
      },
      tracking: {
        title: 'Online-Verfolgung',
        description: 'Überwachen Sie den Status Ihrer Sendung in Echtzeit'
      },
      insurance: {
        title: 'Vollständige Versicherung',
        description: 'Jede Sendung ist vollständig versichert'
      },
      support: {
        title: '24/7 Support',
        description: 'Professioneller Kundenservice rund um die Uhr'
      },
      consultation: {
        title: 'Beratungen',
        description: 'Kostenlose Beratungen zu internationalen Transfers'
      },
      ctaTitle: 'Brauchen Sie Hilfe?',
      ctaDescription: 'Kontaktieren Sie uns, um mehr über unsere Dienstleistungen zu erfahren.',
      contactButton: 'Kontaktieren Sie uns',
      callButton: 'Jetzt anrufen'
    },

    // About page
    about: {
      title: 'Über EXPRESS HUB',
      subtitle: 'Marktführer in der Geldtransfer-Branche',
      description: 'EXPRESS HUB ist ein modernes Unternehmen, das sich auf sichere Geldtransfers spezialisiert hat. Wir sind auf dem europäischen Markt tätig und bieten schnelle und zuverlässige Kurierdienste.',
      mission: {
        title: 'Unsere Mission',
        description: 'Wir bieten sichere und schnelle Geldtransfers und bauen Kundenvertrauen durch Professionalität und Zuverlässigkeit auf.'
      },
      values: {
        title: 'Unsere Werte',
        security: 'Sicherheit',
        reliability: 'Zuverlässigkeit',
        speed: 'Geschwindigkeit',
        trust: 'Vertrauen'
      },
      team: {
        title: 'Unser Team',
        description: 'Erfahrene Spezialisten mit jahrelanger Erfahrung in der Finanz- und Logistikbranche.'
      },
      contact: {
        title: 'Kontaktieren Sie uns',
        description: 'Wir sind 24/7 verfügbar, um Ihre Fragen zu beantworten.'
      }
    },

    // Contact page
    contact: {
      title: 'Kontakt',
      subtitle: 'Nehmen Sie Kontakt mit uns auf',
      form: {
        title: 'Nachricht senden',
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        phone: 'Telefon',
        subject: 'Betreff',
        message: 'Nachricht',
        submit: 'Nachricht senden',
        sending: 'Wird gesendet...',
        success: 'Nachricht erfolgreich gesendet!',
        error: 'Ein Fehler ist beim Senden der Nachricht aufgetreten.'
      },
      info: {
        phone: {
          title: 'Telefon',
          description: 'Antwort innerhalb von 24h'
        },
        email: {
          title: 'E-Mail',
          description: 'Antwort innerhalb von 24h'
        },
        address: {
          title: 'Adresse',
          description: '6883 Novazzano, Schweiz'
        },
        hours: {
          title: 'Öffnungszeiten',
          description: 'Wochenenden: 11:00-16:00'
        }
      },
      callNow: 'Jetzt anrufen'
    },

    // Admin panel
    admin: {
      title: 'Admin-Panel',
      subtitle: 'EXPRESS HUB Bestellungen verwalten',
      stats: {
        total: 'Gesamt',
        unpaid: 'Unbezahlt',
        pending: 'Bestätigung ausstehend',
        confirmed: 'Bestätigt',
        inTransit: 'Unterwegs',
        delivered: 'Zugestellt',
        cancelled: 'Storniert'
      },
      filters: {
        title: 'Filter und Suche',
        searchPlaceholder: 'Suche nach Nummer, Name, E-Mail...',
        allStatuses: 'Alle Status'
      },
      orders: {
        title: 'Bestellungen',
        noOrders: 'Keine Bestellungen anzuzeigen',
        sender: 'Absender',
        recipient: 'Empfänger',
        orderDetails: 'Bestelldetails',
        senderData: 'Absender-Daten',
        recipientData: 'Empfänger-Daten',
        financialDetails: 'Finanzielle Details',
        additionalInfo: 'Zusätzliche Informationen',
        serviceAmount: 'Zu überweisender Betrag',
        serviceFee: 'Servicegebühr',
        insurance: 'Versicherung',
        totalAmount: 'Gesamtbetrag',
        deliveryType: 'Lieferart',
        orderDate: 'Bestelldatum',
        expressDelivery: 'Express (24-48h)',
        standardDelivery: 'Standard (3-5 Tage)',
        updateSuccess: 'Bestellstatus erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren des Bestellstatus'
      }
    },

    // Status labels
    status: {
      unpaid: 'Unbezahlt',
      pending: 'Bestätigung ausstehend',
      confirmed: 'Bestätigt',
      inTransit: 'Unterwegs',
      delivered: 'Zugestellt',
      cancelled: 'Storniert'
    },

    // Status descriptions
    statusDesc: {
      unpaid: 'Bestellung wartet auf Zahlung. Bitte kontaktieren Sie uns zur Zahlungsabwicklung.',
      pending: 'Ihre Bestellung wurde erhalten und wartet auf Bestätigung',
      confirmed: 'Bestellung wurde bestätigt und wird für den Versand vorbereitet',
      inTransit: 'Sendung ist auf dem Weg zum Empfänger',
      delivered: 'Sendung wurde an den Empfänger zugestellt',
      cancelled: 'Bestellung wurde storniert'
    },

    // Footer
    footer: {
      description: 'EXPRESS HUB - Professionelle Kurierdienste und Geldtransfers.',
      quickLinks: 'Schnelle Links',
      services: 'Dienstleistungen',
      contact: 'Kontakt',
      hours: 'Öffnungszeiten',
      workingHours: 'Mo-Fr 8:00-18:00, Sa-So: 11:00-16:00',
      copyright: '© 2026 EXPRESS HUB. Alle Rechte vorbehalten.'
    },

    // Working hours
    workingHours: {
      weekdays: 'Mo-Fr: 8:00-18:00',
      weekends: 'Sa-So: 11:00-16:00',
      full: 'Mo-Fr 8:00-18:00, Sa-So: 11:00-16:00'
    }
  }
};

export type Language = 'pl' | 'en' | 'de';
export type TranslationKey = keyof typeof translations.pl;